import { render, staticRenderFns } from "./LocationsDialog.vue?vue&type=template&id=398d7193&scoped=true&"
import script from "./LocationsDialog.vue?vue&type=script&lang=js&"
export * from "./LocationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LocationsDialog.vue?vue&type=style&index=0&id=398d7193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d7193",
  null
  
)

/* custom blocks */
import block0 from "./LocationsDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports